const hospitalAtHomeImagePaths = {
  480: "/care/hospitalAtHome480.avif",
  768: "/care/hospitalAtHome768.avif",
  1366: "/care/hospitalAtHome1366.avif",
};

export const imagePathsDefault = hospitalAtHomeImagePaths;
export const imagePathsHahag = hospitalAtHomeImagePaths;
export const imagePathsKsgr = hospitalAtHomeImagePaths;
export const imagePathsRakus = hospitalAtHomeImagePaths;
